import { useEffect } from "react";

/**
 * Suffix kept on every page so a tab is identifiable as this app; the
 * distinguishing part comes first because tab strips truncate from the right.
 */
const APP_NAME = "Moreta Admin";

/**
 * Sets `document.title` to "<title> · Moreta Admin".
 *
 * A nullish title is ignored rather than reset to a placeholder, so a page
 * whose name is still loading (the user 360, which titles itself with the
 * customer's email) keeps the previous title until it resolves instead of
 * flashing. Every route sets one, so nothing needs restoring on unmount.
 *
 * Most pages never call this directly — `PageHeader` does it with the same
 * string it renders as the <h1>, which is what keeps the tab and the page
 * from drifting apart.
 */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (!title) return;
    document.title = `${title} · ${APP_NAME}`;
  }, [title]);
}
